import { Box, Button, Chip, Divider, Typography } from "@mui/material";

export const KOT_STATUS = {
  PREPARING: {
    id: 1,
    label: "Preparing",
    color: "#f59e0b",
  },
  READY: {
    id: 2,
    label: "Ready",
    color: "#22c55e",
  },
  CANCELLED: {
    id: 3,
    label: "Cancelled",
    color: "#ef4444",
  },
};

export default function KotDetailView({ kot, onReopenKot }) {
  const status = KOT_STATUS[kot.status];

  return (
    <Box
      sx={{ p: 2.5, height: "100%", display: "flex", flexDirection: "column" }}
    >
      {/* HEADER */}
      <Box sx={{ mb: 2 }}>
        <Typography fontWeight={700} fontSize="18px">
          KOT #{kot.kotNo}
        </Typography>

        <Typography variant="body2" sx={{ color: "#64748b" }}>
          Order #{kot.orderNo}
        </Typography>
      </Box>

      {/* STATUS + META */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 2,
        }}
      >
        <Chip
          label={status.label}
          size="small"
          sx={{
            height: 22,
            fontSize: "12px",
            fontWeight: 600,
            backgroundColor: status.color,
            color: "#fff",
          }}
        />

        <Typography variant="body2" sx={{ color: "#475569" }}>
          {kot.orderType}
        </Typography>

        <Typography variant="body2" sx={{ color: "#94a3b8" }}>
          • {kot.floor}
        </Typography>
      </Box>

      <Typography variant="caption" sx={{ color: "#94a3b8", mb: 2 }}>
        Completed at {kot.completedAt}
      </Typography>

      <Divider />

      {/* ITEMS */}
      <Box sx={{ mt: 2, flex: 1 }}>
        <Typography fontWeight={600} mb={1}>
          Items
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
          {kot.items.map((item) => (
            <Box
              key={item.id}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 1,
                py: 0.75,
                borderRadius: "6px",
                backgroundColor: "#f8fafc",
              }}
            >
              <Typography variant="body2">{item.name}</Typography>

              <Typography
                variant="body2"
                fontWeight={600}
                sx={{ color: "#334155" }}
              >
                × {item.qty}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {/* ACTION */}
      {(kot.status === "CANCELLED" || kot.status === "READY") && (
        <Box sx={{ pt: 2 }}>
          <Button
            fullWidth
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              backgroundColor: status.color,
              "&:hover": {
                backgroundColor: status.color,
                opacity: 0.9,
              },
            }}
            onClick={() => onReopenKot(kot.id)}
          >
            Mark as Ready Again
          </Button>
        </Box>
      )}
    </Box>
  );
}
